import {
  Module, VuexModule, Mutation, Action
} from 'vuex-module-decorators';
import api from '@/api/api';

@Module({ namespaced: true })
export default class extends VuexModule {
  @Action
  async getStadiums(params: any) {
    return api.getStadiums(params);
  }

  @Action
  async getAdBanners(params: any) {
    return api.getAdBanners(params)
  }

  @Action
  async getUsers(params: any) {
    return api.getUsers(params);
  }

  @Action
  async getArea(params: any) {
    return api.getArea(params);
  }

  @Action
  async getOpenArea(params: any) {
    return api.getOpenArea(params);
  }

  @Action
  async addOpenArea(params: any) {
    return api.addOpenArea(params);
  }

  @Action
  async uploadApk(params: any) {
    return api.uploadApk(params);
  }

  @Action
  async changeFieldValue(params: any) {
    return api.changeFieldValue(params);
  }

  @Action
  async getAreaTree(params: any) {
    return api.getAreaTree(params);
  }

  @Action
  async getApplist(params: any) {
    return api.getApplist(params);
  }

  @Action
  async sendReleaseSms(params: any) {
    return api.sendReleaseSms(params);
  }

  @Action
  async areastr(params: any) {
    return api.areastr(params)
  }

  @Action
  async authusergroups(params: any) {
    return api.authusergroups(params)
  }
}
